import { render } from "./lightbox.vue?vue&type=template&id=1fa3e079"
import script from "./lightbox.vue?vue&type=script&lang=js"
export * from "./lightbox.vue?vue&type=script&lang=js"

import "./lightbox.vue?vue&type=style&index=0&id=1fa3e079&lang=css"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__